import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import { Link } from 'react-router-dom';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import { StatusPill, ActionIconButton, ListPageShell, EmptyState } from '../../Components/Ui'

const EventList = ({ nameSingle, separator, namePlural }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.event.get_event({
                p_paginate: ''
            }).then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const [dataDeleted, setDataDeleted] = useState({})
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.event.event_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleShowModalDelete = e => {
        let { idEvent, nameEvent } = e.currentTarget.dataset
        setDataDeleted({
            p_id_event: idEvent,
            p_name_event: nameEvent
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const handleShowInDashboard = e => {
        let { idEvent, mainEvent } = e.currentTarget.dataset

        Controllers.event.event_main_update({
            p_main_event: mainEvent,
            p_id_event: idEvent
        }).then(res => {
            setReload(true)
            Helpers.toast.construct({ ...res, toast })
        })
    }

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_event', text: 'ID', align: 'center' },
                { name: 'name_event', text: 'Nombres' },
                { name: 'file_images', text: 'Imagen', render: r => <img className="img-thumbnail" width="100" src={Helpers.config.resourcesUrl({ url: r.file_images })} />, align: 'center' },
                { name: 'name_category', text: 'Departamento' },
                { name: 'main_event', text: 'En Escritorio', align: 'center', render: r => <div className="sp-row-actions" style={{ justifyContent: 'center' }}>
                    <StatusPill tone={parseInt(r.main_event) === 1 ? 'success' : 'danger'}>
                        {parseInt(r.main_event) === 1 ? 'SI' : 'NO'}
                    </StatusPill>
                    <ActionIconButton
                        tone="ghost"
                        icon="fas fa-retweet"
                        label="Cambiar"
                        data-id-event={r.id_event}
                        data-main-event={parseInt(r.main_event) === 1 ? 0 : 1}
                        onClick={handleShowInDashboard}
                    />
                </div> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        <Link to={Helpers.config.convertUrl({ url: '/evento/' + u.token_event })}>
                            <ActionIconButton tone="ghost" icon="fas fa-link" label="Ver" />
                        </Link>
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-event={u.id_event} onClick={handleShowModalDelete} data-name-event={u.name_event} />
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Consulta y administra los eventos publicados desde un solo lugar."
            badge="Actividad actualizada"
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Título, departamento…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-calendar"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o publica un nuevo evento para empezar."
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_event} - {dataDeleted.p_name_event}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default EventList
